import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EditorInputField, SiteHeader } from '../../../../editor-container/editor-model';
import { HeaderEditorStoreService } from '../../header-editor-store.service';
import { PreviewEditStoreService } from './../../../../services/preview-edit-store.service';
import { Site } from './../../../../editor-container/editor-model';
import { HeaderConfig, HeaderThemeEnum } from '@urbannex/storethemes';
import { ToggleComponent } from '../../../field-editor/toggle/toggle.component';
import { FieldEditorComponent } from '../../../field-editor/field-editor.component';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { FieldUpdaterService } from '../../../field-editor/field-updater.service';
import { InputField } from '../../../../model';
import { HeaderThemeStateService } from './header-theme-state.service';

@Component({
  selector: 'ngx-header-theme',
  templateUrl: './header-theme.component.html',
  styleUrls: ['./header-theme.component.scss']
})
export class HeaderThemeComponent implements OnInit{
  @Input() headerType:string;
  darkMode:boolean;
  headerConfig:any;
  mainHeaderBackground:string;
  isCustom:boolean = false;
  trackFieldUpdate$:Subscription;
  initialized:boolean = false

  customField:EditorInputField;
  themeField:EditorInputField;
  backgroundField:EditorInputField;
  textColorField:EditorInputField;

  themeEnum:HeaderThemeEnum;

  fields:EditorInputField[] = [
    {
      name:"themeMode",
      title:"Light/Dark Mode",
      type:"option",
      controlType:"radio",
      value:null,
      context:{
        key:"mainDark",
        section:"header",
        cellId:null,
        options:[
          { value: HeaderThemeEnum.DARK, label: 'Dark Mode' },
          { value: HeaderThemeEnum.DEFAULT, label: 'Light Mode' }
      ]
      }
    },
    {
      name:"custom-toggle",
      controlType:"toggle",
      title:"Custom Colors",
      type:"toggle",
      value:null,
      context:{
        key:"custom",
        section:"header",
        cellId:null,
        label:"Toggle Custom",
        field:"background",
        fieldValue:null,
        options:[
          { value: HeaderThemeEnum.CUSTOM, checked:true },
          { value: HeaderThemeEnum.DEFAULT, checked:false}
        ]        
      }
    },
    {
      name:"background",
      title:"Background",
      type:"background",
      value:null,
      controlType:'theme-color-picker',
      context:{
        key:"background",
        section:"header",
        cellId:null
      }
    },
    {
      name:"textColor",
      title:"Text Color",
      type:"color",
      value:null,
      controlType:'text-color-picker',
      context:{
        key:"color",
        section:"header",
        cellId:null
      }
    }
    
    /* ,
    {
      name:"width",
      title:"Width",
      type:'width',
      controlType:'singleMeasure'
    },
    {
      name:'padding',
      title:'Padding',
      type:'padding',
      controlType:'multiMeasure'
    },
    {
      name:"margin",
      title:"Margin",
      type:"margin",
      controlType:"multiMeasure"
    },
    {
      name:'border',
      title:"Border",
      type:"border",
      controlType:"multiMeasure"
    },
    {
      name:"seo",
      title:"SEO",
      type:"group",
      controlType:'dialog'
    } */
  ]

  @ViewChild('toggleCustom') toggleCustom:ToggleComponent;

  constructor(private fieldUpdaterService:FieldUpdaterService,
    private headerEditorStore:HeaderEditorStoreService,
    private themeStateService:HeaderThemeStateService,
    private previewEditStore:PreviewEditStoreService){
  }
  
  
  
  ngOnInit(): void {
    this.customField = this.fields.find(field => field.name == "custom-toggle");
    this.themeField = this.fields.find(field => field.name == "themeMode");
    this.backgroundField = this.fields.find(field => field.name == "background");
    this.textColorField = this.fields.find(field => field.name == "textColor");
    this.previewEditStore.selectedSite$.subscribe((_selectedSite:Site) => {
      if(_selectedSite != null && _selectedSite != undefined){
        let siteHeader:HeaderConfig = _selectedSite.siteHeader;
        //siteHeader.m
        switch (this.headerType) {
          case "mainHeader":
            //Theme Field
            this.darkMode = siteHeader.mainHeaderConfig.mainDark;
            //Custom Field
            this.headerConfig = siteHeader.mainHeaderConfig;
            this.themeEnum = siteHeader.mainHeaderConfig.themeEnum?siteHeader.mainHeaderConfig.themeEnum:HeaderThemeEnum.DEFAULT;
            //Set Field Values
            this.themeField.value = this.themeEnum;
            if(this.themeEnum == HeaderThemeEnum.CUSTOM){
              this.customField.value = HeaderThemeEnum.CUSTOM;
              this.isCustom = siteHeader.mainHeaderConfig.custom;
            }else{
              this.customField.value = HeaderThemeEnum.DEFAULT;
            }

            //Set Field Contexts
            //CustomField
            this.customField.context["cellId"] = "main";
            this.themeField.context["cellId"] = "main";
            this.customField.context["fieldValue"] = siteHeader.mainHeaderConfig.background?siteHeader.mainHeaderConfig.background:"";
            //Background Field
            this.backgroundField.context["cellId"] = "main";
            //TextColorField
            this.textColorField.context["cellId"] = "main";
            this.textColorField.value = siteHeader.mainHeaderConfig.color?siteHeader.mainHeaderConfig.color:"#222b45";
            console.log({MainHeader:this.customField});
            break;
          case "topHeader":
            this.darkMode = siteHeader.topHeaderConfig.mainDark;
            this.headerConfig = siteHeader.topHeaderConfig;
            this.customField.context["cellId"] = "top";
            this.themeField.context["cellId"] = "top";
             //TextColorField
             this.textColorField.context["cellId"] = "top";
             //Background Field
             this.backgroundField.context["cellId"] = "top";  
            break;
          case "bottomHeader":
            this.darkMode = siteHeader.bottomHeaderConfig.mainDark;
            this.headerConfig = siteHeader.bottomHeaderConfig;
            this.customField.context["cellId"] = "bottom";
            this.themeField.context["cellId"] = "bottom";
             //TextColorField
             this.textColorField.context["cellId"] = "bottom";
             //Background Field
             this.backgroundField.context["cellId"] = "bottom";  
            break;
        
          default:
            break;
      }
       /* let mainHeaderConfig = _selectedSite.siteHeader.mainHeaderConfig;
       let mainHeaderCustom = mainHeaderConfig.custom;
       let bottomHeaderConfig = _selectedSite.siteHeader.bottomHeaderConfig;
       let topHeaderConfig = _selectedSite.siteHeader.topHeaderConfig;
       this.darkMode = _selectedSite.siteHeader.mainHeaderConfig.mainDark;
       if(_selectedSite.siteHeader.mainHeaderConfig.background){
        this.mainHeaderBackground = _selectedSite.siteHeader.mainHeaderConfig.background;
       }; */
       
       //this.themeField.value = this.darkMode;
       setTimeout(() => {
        this.initialized = true
       }, 100);
      }      
    })
    this.fieldUpdaterService.trackUpdatedField.subscribe((_field:InputField) => {
      let field = _field;
      if(field.controlType == "toggle"){
        console.log(_field);
        if(field.value == HeaderThemeEnum.CUSTOM){
          this.isCustom = true
        }else if(field.value == HeaderThemeEnum.DARK || field.value == HeaderThemeEnum.DEFAULT){
          this.isCustom = false;
        }
        //this.isCustom = field.value;
        console.log(this.isCustom);
      }
    });
  }

  onFieldUpdate(e){
    console.log(e);
  }

  initStateSubScription(){
    /* this.siteHeader$ = this.headerEditorStore.headerConfigState$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    }); */
    /* this.siteHeader$ = this.previewEditStore.siteHeader$
      .pipe(
        takeUntil(this.destroy$),
        tap((siteHeader:HeaderConfig) => {
          console.log(siteHeader);
          switch (this.headerType) {
            case "main":
              this.isCustom = siteHeader.mainHeaderConfig.custom ;             
              break;
            case "top":
              this.isCustom = siteHeader.topHeaderConfig.custom;
              break;
            case "bottom":
              this.isCustom = siteHeader.bottomHeaderConfig.custom;
              break;
          
            default:
              break;
          }
        })).subscribe() */
  }


}
